/**
 * Subcampos declarados para cada item de um campo `array` de nó.
 *
 * Um nó cujo campo `array` não declara `items.fields` devolve lista vazia em vez
 * de derrubar o editor inteiro com "Cannot read properties of undefined
 * (reading 'fields')" (AB#86814).
 */
export function getArrayItemFields<T = Record<string, unknown>>(field: unknown): T[] {
  const items = (field as { items?: { fields?: unknown } } | null | undefined)?.items
  return Array.isArray(items?.fields) ? (items.fields as T[]) : []
}
